var exports = {
  "U": "splitter-S2J0N",
  "r": "outline-S2J0N",
};

module.exports = exports;
